import { Outlet } from "react-router-dom";
import AppShell from "./AppShell";

const SidebarLayout = () => (
  <AppShell>
    <Outlet />
  </AppShell>
);

export default SidebarLayout;
